import axios from 'axios'

const URL_PATH = '/ata-registro-preco/api/public/pedidos/documentos'

class DocumentosPedidoApiClient {
	async baixar(idDocumento) {
		let url = `${URL_PATH}/${idDocumento}/baixar`

		return await axios.get(url, { responseType: 'arraybuffer' })
	}
}

export default new DocumentosPedidoApiClient()
